import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Leg } from '@features/planification-map/components/route-form/models/routeRequestResults.model';
import { MatIconModule } from '@angular/material/icon';
import { allOption, bikeOption, busOption, walkOption } from '@features/planification-map/components/route-form/components/route-form-options-panels/components/route-form-more-options/constants';

@Component({
  selector: 'app-leg-banner',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './leg-banner.component.html',
  styleUrls: ['./leg-banner.component.scss']
})
export class LegBanner {

  @Input({required: true}) legs!: Leg[];
  
  public busId = busOption.id.toUpperCase();
  public walkId= walkOption.id.toUpperCase();
  public bicycleId = bikeOption.id.toUpperCase();
  public allId = allOption.id.toUpperCase();


}
